import httpAuth from '@/services/httpAuth'

import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/admin/reports?${serialize(filtros)}`, { tela: 'report' })
}

export async function excel (filtros) {
  return httpAuth.post(`/admin/exportarexcel?${filtros}`)
}
